import React, { Component } from 'react';
import classnames from 'classnames';
import styles from './styles.styl';

class UploadButton extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const { disabled } = this.props;

    if (disabled) {
      event.preventDefault();
    }
  }

  render() {
    const { children, value, onChange, multiple, disabled, primary } = this.props;

    return (
      <label className={classnames(styles.container, { [styles.disabled]: disabled }, { [styles.primary]: primary }, this.props.className)} onClick={this.onClick}>
        <input
          type="file"
          accept=".doc,.docx,.pages,.txt,.csv,.xlsx,.xls,.pdf,"
          value={value || ''}
          onChange={onChange}
          className={styles.input}
          multiple={multiple}
          disabled={disabled}
        />
        {children}
      </label>
    );
  }

}

export default UploadButton;



// WEBPACK FOOTER //
// ./src/components/shared/UploadButton/index.js